var paragraph_default = {
  "fontElementMap": "_983or",
  "elementSpacing": "W2aKK",
  "text": "EY0Xg W2aKK",
  "child": "_1Kc57"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
